import React from "react";
import LinkLoad from "@/Layouts/LinkLoad";

export default function TextAgreement(props) {
    const {className = '', textButton = 'Отправить', location = ''} = props;

    return <div className={`textAgreement${className && ' ' + className}`}>
        Нажимая кнопку «{textButton}», вы соглашаетесь с
        условиями <LinkLoad href={`/politika-konfidencialnosti`} className={`form__personal`} target={`_blank`}>
        обработки персональных данных
    </LinkLoad>
        {location === 'basket' && (
            <>
                <span> и </span>
                <a href={`/storage/docs/dogovor_publichnoy_oferti.pdf`}
                   className={`form__personal`}
                   target={`_blank`}>
                    договора оферты
                </a>
            </>
        )}
    </div>
}

// <span>
//                           <span>Даю согласие на </span>
//                           <LinkLoad href={`/politika-konfidencialnosti`}
//                                     className={`form__personal`}
//                                     target={`_blank`}>
//                               обработку персональных данных
//                           </LinkLoad>
//                           <>
//                               <span> и на участие в </span>
//                               <LinkLoad href={`/platina-benefits`}
//                                         className={`form__personal`}
//                                         target={`_blank`}>
//                                   бонусной программе
//                               </LinkLoad>
//                           </>
//                       </span>
